export function toFormUrlEncoded(data: Record<string, unknown>): URLSearchParams {
    const params = new URLSearchParams();
    for (const [k, v] of Object.entries(data)) {
        if (v !== undefined && v !== null) params.append(k, String(v));
    }
    return params;
}
